export const EMPTY_SORT_KEYS = { text: null, number: null, date: null };
/**
 * monday's column width when the row stores none — 140 for every type measured on this account
 * (P-022; `people` 98 and `creation_log` / `last_updated` 135 are the three exceptions, each
 * declared in its own folder).
 */
export const DEFAULT_COLUMN_WIDTH = 140;
/** Thrown by `parseValue` / `fromMondayValue` when input cannot be coerced. */
export class ColumnValueError extends Error {
    columnType;
    reason;
    constructor(columnType, message, reason) {
        super(`${columnType}: ${message}`);
        this.columnType = columnType;
        this.reason = reason;
        this.name = 'ColumnValueError';
    }
}
/**
 * The half a rule's `compare_attribute` names, or `null` when the rule names none and when the
 * type declares no such half (a stray attribute must not fail a saved filter — monday accepts
 * `compare_attribute` on any rule, and `toMondayQuery` round-trips it verbatim).
 */
export function compareAttributeSpec(definition, attribute) {
    if (attribute === null || attribute === undefined || attribute === '')
        return null;
    return definition.compareAttributes?.[attribute] ?? null;
}
/** Helper that keeps the generic parameters inferred while enforcing the contract. */
export function defineColumnType(definition) {
    return definition;
}
//# sourceMappingURL=types.js.map